import React from 'react';

import { Field } from 'react-final-form';

import { FieldSpanView } from './FieldSpan.view';

export const FieldSpan = ({ name }: { name: string }) => (
  <Field
    name={name}
    render={({ input }) => (
      <FieldSpanView>
        <b>{input.value?.value || input.value}</b>
        {input.value?.example && <i>(eg. {input.value.example})</i>}
      </FieldSpanView>
    )}
  />
);
